import { render, staticRenderFns } from "./TranslateTreeItem.vue?vue&type=template&id=b061e8aa&scoped=true&"
import script from "./TranslateTreeItem.vue?vue&type=script&lang=js&"
export * from "./TranslateTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./TranslateTreeItem.vue?vue&type=style&index=0&id=b061e8aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b061e8aa",
  null
  
)

export default component.exports